import { object, ObjectSchema, string } from 'yup';

import { Remit } from '@/types/billing';
import { transformEmptyStringToNull } from '@/utils/transformEmptyStringToNull';

export const RemitSchema: ObjectSchema<
  Omit<
    Remit,
    | 'id'
    | 'financial_info'
    | 'remit_claims'
    | 'first_financial_info'
    | 'created_at'
    | 'updated_at'
    | 'ingested_at'
    | 'type'
    | 'polymorphic_id'
  >
> = object().shape({
  status: string().required().max(50).transform(transformEmptyStringToNull),
  ingested_from: string().nullable().max(100).transform(transformEmptyStringToNull),
  filename: string().nullable().max(100).transform(transformEmptyStringToNull),
  file: string().nullable().url(),
  parent_filename: string().nullable().max(100).transform(transformEmptyStringToNull),
  transmission_on: string().nullable().transform(transformEmptyStringToNull),
  trace_type_code: string().nullable().max(50).transform(transformEmptyStringToNull)
});
